/**
 * Hand a table to the browser as a CSV download.
 *
 * Rows are arrays of cells; every cell is quoted, so commas, quotes and
 * newlines inside a username or a server name cannot split a column. CRLF
 * line ends because that is what Excel expects when it opens one cold.
 */
export const downloadCsv = (filename: string, rows: Array<Array<string | number | null | undefined>>) => {
    const cell = (v: string | number | null | undefined) => {
        let s = String(v ?? '')
        // Usernames are player-chosen. One starting with = + - @ is run as a
        // formula when the file is opened in Excel or Sheets ("=HYPERLINK(...)"),
        // so text cells get a leading apostrophe. Numbers are left alone so a
        // negative amount stays a number.
        if (typeof v === 'string' && /^[=+\-@\t\r]/.test(s)) s = `'${s}`
        return `"${s.replace(/"/g, '""')}"`
    }
    const csv = rows.map((r) => r.map(cell).join(',')).join('\r\n')
    const blob = new Blob(['﻿' + csv], { type: 'text/csv;charset=utf-8' })
    const a = document.createElement('a')
    a.href = URL.createObjectURL(blob)
    a.download = filename.endsWith('.csv') ? filename : `${filename}.csv`
    // Attached and revoked on the next tick: Firefox ignores a click on a
    // detached link, and revoking synchronously can cancel the download in
    // Safari before it starts.
    document.body.appendChild(a)
    a.click()
    setTimeout(() => {
        URL.revokeObjectURL(a.href)
        a.remove()
    }, 0)
}

/** A filename that will not upset a filesystem. */
export const safeName = (s: string) => s.replace(/[^\w.-]+/g, '_').replace(/^_+|_+$/g, '') || 'export'
